import { useMemo } from "react";
import { generateColumnsDefaultConfiguration } from "../../../components/dataGrid/columnHelpers";
import { useGetBreakpoints } from "../../../responsiveTools/breakpoints";

export const useGetGrillaConsulta = (resultados, mostrarGrilla) => {

    const { isMobile } = useGetBreakpoints();

    const rows = useMemo(() => {
        if (!mostrarGrilla || resultados.length === 0) return [];
        return resultados;
    }, [resultados, mostrarGrilla]);

    const columns = useMemo(() => {
        if (!mostrarGrilla || resultados.length === 0) return [];
        const firstRow = resultados[0];
        const baseColumns = Object.keys(firstRow).map(key => ({
            field: key,
            headerName: key,
            minWidth: 120,
        }));
        return generateColumnsDefaultConfiguration(baseColumns, isMobile);
    }, [resultados, mostrarGrilla]);

    return { rows, columns };
}